var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  width: 137,
  height: 97,
  rx: 5.46549,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131.604 96.2128H6.65372C6.27233 96.2128 5.89084 96.2151 5.50945 96.2128C2.95312 96.2272 0.863382 94.2216 0.82894 91.7207C0.809896 90.5172 0.82894 89.3118 0.82894 88.1081V10.0949C0.82894 8.52897 0.820205 6.96269 0.82894 5.3968C0.800881 2.886 2.85455 0.826362 5.42069 0.791697C5.66355 0.788035 5.90676 0.791697 6.14961 0.791697H128.1C129.243 0.791697 130.387 0.779889 131.53 0.791697C134.081 0.785216 136.162 2.78998 136.195 5.28594C136.2 5.62567 136.195 5.96587 136.195 6.30562V90.1468C136.195 90.6337 136.197 91.1207 136.195 91.6077C136.222 94.1178 134.169 96.1769 131.604 96.2128C131.088 96.2223 131.086 97.0077 131.604 96.9981C134.579 96.9584 136.975 94.599 136.997 91.6882C137.003 91.2562 136.997 90.8239 136.997 90.3919V6.25812C136.997 5.93349 137.003 5.60838 136.997 5.28376C136.958 2.37699 134.553 0.0330644 131.582 0.00633344C130.549 -0.0079168 129.514 0.00633344 128.48 0.00633344H6.05977C5.72064 0.00633344 5.37712 -0.00465445 5.03874 0.0203435C2.21159 0.249439 0.0339965 2.55743 0.0262572 5.33296C0.00711016 6.79145 0.0262572 8.25142 0.0262572 9.7101V88.1655C0.0262572 89.4384 -0.038405 90.7293 0.0352171 92.0011C0.219862 94.7993 2.58453 96.9814 5.45034 96.9981C5.77097 97.0023 6.09195 96.9981 6.41258 96.9981H131.604C132.12 96.9981 132.121 96.2128 131.604 96.2128Z",
  fill: "#516A85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 15V3.57026C0 1.59846 1.4707 0 3.2849 0H133.715C134.586 0 135.422 0.376152 136.038 1.04571C136.654 1.71526 137 2.62337 137 3.57026V15H0Z",
  fill: "#516A85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.827664 14.5722V5.80445C0.827664 4.59397 0.633592 3.14992 1.34263 2.10531C1.92543 1.24667 2.8493 0.851684 3.83838 0.844746C5.97257 0.829794 8.10741 0.844746 10.2416 0.844746H132.466C133.748 0.844746 134.98 0.957674 135.761 2.25556C136.395 3.30916 136.182 4.84283 136.182 6.03129V14.5722L136.583 14.1585H5.95335C4.18917 14.1585 2.42186 14.1268 0.657871 14.1585C0.580758 14.1598 0.503501 14.1585 0.426347 14.1585C-0.0900872 14.1585 -0.0909462 14.9859 0.426347 14.9859H131.056C132.82 14.9859 134.587 15.0176 136.351 14.9859C136.429 14.9846 136.506 14.9859 136.583 14.9859C136.803 14.9828 136.981 14.7994 136.984 14.5722V5.6942C136.984 4.45928 137.129 3.11976 136.541 1.99354C135.877 0.767703 134.619 0.0107297 133.257 0.0172363C131.253 -0.0215453 129.244 0.0172363 127.24 0.0172363H4.33569C4.13912 0.0172363 3.94214 0.0133982 3.74562 0.0172363C2.29242 0.012894 0.969105 0.879161 0.354777 2.23694C-0.135169 3.34891 0.025051 4.72501 0.025051 5.91687V14.5722C0.025051 15.1047 0.827664 15.1056 0.827664 14.5722Z",
  fill: "#516A85"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.3146,
  cy: 7.58412,
  r: 2.14271,
  fill: "#F4F6F8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 20.6271,
  cy: 7.58412,
  r: 2.14271,
  fill: "#F4F6F8"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 28.9376,
  cy: 7.58412,
  r: 2.14271,
  fill: "#F4F6F8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 51,
  y: 25,
  width: 79,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 59,
  width: 121,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 83,
  width: 81,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 51,
  y: 33,
  width: 79,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 67,
  width: 81,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9,
  y: 75,
  width: 81,
  height: 2,
  rx: 0.5,
  fill: "#96ABBB"
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.18164,
  y: 23.1055,
  width: 36.8184,
  height: 13.8945,
  rx: 1.56992,
  stroke: "#516A85",
  strokeWidth: 0.285441
}), /*#__PURE__*/React.createElement("rect", {
  x: 9.18164,
  y: 42.022,
  width: 120.818,
  height: 12.274,
  rx: 1.56992,
  stroke: "#516A85",
  strokeWidth: 0.285441
}), /*#__PURE__*/React.createElement("rect", {
  x: 96,
  y: 64.6128,
  width: 33.8448,
  height: 24.661,
  rx: 1.56992,
  stroke: "#516A85",
  strokeWidth: 0.285441
}));
function SvgForms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 97,
    viewBox: "0 0 137 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/forms.45c1ed812a27a6d544e8f60618885146.svg";
export { ForwardRef as ReactComponent };